'use strict';

angular.module('amexReconciliationApp').filter('userPreferenceDateFormat',
  function dateFormatter($filter, UserModel, dateFormats) {

    function getTimeZoneSuffix() {
      var now = new Date().toString();

      var regexToGetTimeZoneString = /\((\w+)\)$/g;
      var match = regexToGetTimeZoneString.exec(now);

      if (match != null && match.length > 0) {
        return ' ' + match[1];
      }
      else {
        return '';
      }
    }

    return function (date, displayTime) {
      var dateFormat;

      if (UserModel.currentUser()) {
        dateFormat = dateFormats[UserModel.currentUser().preferredDateFormat] || 'MM/dd/yy';
      } else {
        dateFormat = 'MM/dd/yy';
      }

      if (displayTime) {
        dateFormat += ' H:mm:ss';
        return $filter('date')(date, dateFormat) + getTimeZoneSuffix();
      } else {
        return $filter('date')(date, dateFormat);
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/userPreferenceDateFormat.js
// module id = 563
// module chunks = 0